import { render, staticRenderFns } from "./UiCheckboxSwitch.vue?vue&type=template&id=4d6f74cb"
import script from "./UiCheckboxSwitch.vue?vue&type=script&lang=js"
export * from "./UiCheckboxSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports